import React from "react";

function Lucknow(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M1.96143 8.69922H21.4717V21.2269H1.96143V8.69922Z"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M3.88843 7.08887H19.6062"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M3.88894 8.69921V3.66625C3.89553 3.5498 3.87829 3.43324 3.83826 3.32369C3.79823 3.21414 3.73627 3.11391 3.65616 3.02915C3.57606 2.94438 3.47949 2.87685 3.37238 2.8307C3.26527 2.78455 3.14986 2.76074 3.03323 2.76074C2.9166 2.76074 2.80119 2.78455 2.69408 2.8307C2.58697 2.87685 2.4904 2.94438 2.4103 3.02915C2.33019 3.11391 2.26822 3.21414 2.2282 3.32369C2.18817 3.43324 2.17093 3.5498 2.17752 3.66625V8.69921H3.88894Z"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M2.177 4.78857H3.88843"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M3.88843 6.56885H2.177"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M3.03442 2.80077V1.99023"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M21.2489 8.69921V3.66625C21.2555 3.5498 21.2383 3.43324 21.1982 3.32369C21.1582 3.21414 21.0963 3.11391 21.0161 3.02915C20.936 2.94438 20.8395 2.87685 20.7324 2.8307C20.6253 2.78455 20.5098 2.76074 20.3932 2.76074C20.2766 2.76074 20.1612 2.78455 20.0541 2.8307C19.947 2.87685 19.8504 2.94438 19.7703 3.02915C19.6902 3.11391 19.6282 3.21414 19.5882 3.32369C19.5482 3.43324 19.5309 3.5498 19.5375 3.66625V8.69921H21.2489Z"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M19.5378 4.78857H21.2493"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M21.2493 6.56885H19.5378"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M20.3951 2.80077V1.99023"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M6.26001 7.08887V8.69898"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M8.91821 7.08887V8.69898"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M11.5815 7.08887V8.69898"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M14.2422 7.08887V8.69898"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M16.9038 7.08887V8.69898"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M5.84158 11.3331V10.5117C5.83122 10.3571 5.76252 10.2123 5.6494 10.1065C5.53628 10.0007 5.38719 9.94189 5.23231 9.94189C5.07744 9.94189 4.92835 10.0007 4.81523 10.1065C4.70211 10.2123 4.63341 10.3571 4.62305 10.5117V11.3331H5.84158Z"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M8.83902 11.3331V10.5117C8.82865 10.3571 8.75996 10.2123 8.64684 10.1065C8.53372 10.0007 8.38463 9.94189 8.22975 9.94189C8.07488 9.94189 7.92578 10.0007 7.81266 10.1065C7.69955 10.2123 7.63085 10.3571 7.62048 10.5117V11.3331H8.83902Z"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M11.8382 11.3331V10.5117C11.8278 10.3571 11.7591 10.2123 11.646 10.1065C11.5329 10.0007 11.3838 9.94189 11.2289 9.94189C11.074 9.94189 10.9249 10.0007 10.8118 10.1065C10.6987 10.2123 10.63 10.3571 10.6196 10.5117V11.3331H11.8382Z"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M14.8362 11.3333V10.5118C14.8125 10.3691 14.739 10.2394 14.6287 10.1459C14.5184 10.0523 14.3784 10.001 14.2338 10.001C14.0891 10.001 13.9492 10.0523 13.8389 10.1459C13.7285 10.2394 13.655 10.3691 13.6313 10.5118V11.3333H14.8362Z"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M17.8349 11.3331V10.5117C17.8245 10.3571 17.7558 10.2123 17.6427 10.1065C17.5296 10.0007 17.3805 9.94189 17.2256 9.94189C17.0707 9.94189 16.9216 10.0007 16.8085 10.1065C16.6954 10.2123 16.6267 10.3571 16.6163 10.5117V11.3331H17.8349Z"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M2.177 11.377H21.4709"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M10.7419 15.1668V13.8881C10.7419 13.3678 10.468 12.9434 10.1312 12.9434C9.79441 12.9434 9.52332 13.3678 9.52332 13.8881V15.1668H10.7419Z"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M13.3716 15.1668V13.8881C13.3716 13.3678 13.0978 12.9434 12.761 12.9434C12.4242 12.9434 12.1531 13.3678 12.1531 13.8881V15.1668H13.3716Z"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M15.9998 15.1668V13.8881C15.9998 13.3678 15.726 12.9434 15.3891 12.9434C15.0523 12.9434 14.7812 13.3678 14.7812 13.8881V15.1668H15.9998Z"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M18.6295 15.1668V13.8881C18.6295 13.3678 18.3557 12.9434 18.0189 12.9434C17.6821 12.9434 17.411 13.3678 17.411 13.8881V15.1668H18.6295Z"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M8.11453 15.1668V13.8881C8.11453 13.3678 7.8407 12.9434 7.50389 12.9434C7.16709 12.9434 6.896 13.3678 6.896 13.8881V15.1668H8.11453Z"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M5.4855 15.1668V13.8881C5.4855 13.3678 5.21168 12.9434 4.87487 12.9434C4.53806 12.9434 4.26697 13.3678 4.26697 13.8881V15.1668H5.4855Z"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M8.12249 21.2264V18.4197C8.13162 18.1937 8.095 17.9683 8.01483 17.7568C7.93466 17.5454 7.81259 17.3523 7.65594 17.1892C7.4993 17.0261 7.31132 16.8963 7.10328 16.8077C6.89524 16.719 6.67143 16.6733 6.44529 16.6733C6.21915 16.6733 5.99534 16.719 5.7873 16.8077C5.57926 16.8963 5.39128 17.0261 5.23464 17.1892C5.07799 17.3523 4.95592 17.5454 4.87575 17.7568C4.79558 17.9683 4.75896 18.1937 4.76809 18.4197V21.2264H8.12249Z"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M13.0512 21.2264V18.4197C13.0603 18.1937 13.0237 17.9683 12.9435 17.7568C12.8634 17.5454 12.7413 17.3523 12.5847 17.1892C12.428 17.0261 12.24 16.8963 12.032 16.8077C11.8239 16.719 11.6001 16.6733 11.374 16.6733C11.1479 16.6733 10.9241 16.719 10.716 16.8077C10.508 16.8963 10.32 17.0261 10.1633 17.1892C10.0067 17.3523 9.88463 17.5454 9.80446 17.7568C9.72429 17.9683 9.68767 18.1937 9.6968 18.4197V21.2264H13.0512Z"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
      <path
        d="M17.9799 21.2264V18.4197C17.989 18.1937 17.9524 17.9683 17.8723 17.7568C17.7921 17.5454 17.67 17.3523 17.5134 17.1892C17.3567 17.0261 17.1687 16.8963 16.9607 16.8077C16.7527 16.719 16.5288 16.6733 16.3027 16.6733C16.0766 16.6733 15.8528 16.719 15.6447 16.8077C15.4367 16.8963 15.2487 17.0261 15.0921 17.1892C14.9354 17.3523 14.8133 17.5454 14.7332 17.7568C14.653 17.9683 14.6164 18.1937 14.6255 18.4197V21.2264H17.9799Z"
        stroke="#17142A"
        strokeWidth="0.364227"
        strokeMiterlimit="10"
      />
    </svg>
  );
}

const MemoLucknow = React.memo(Lucknow);
export default MemoLucknow;
